import { render, staticRenderFns } from "./order_closed.vue?vue&type=template&id=2154f415&scoped=true"
import script from "./order_closed.vue?vue&type=script&lang=js"
export * from "./order_closed.vue?vue&type=script&lang=js"
import style0 from "./order_closed.vue?vue&type=style&index=0&id=2154f415&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2154f415",
  null
  
)

export default component.exports